import React from "react";
import useFirebase from "../infra-no-ui/firebase/useFirebase";
import Firebase from "../infra-no-ui/firebase/Firebase";
import useTranslationAuthenticationNoUi from "./useTranslationAuthenticationNoUi";

export default function useUpdatePassword() {

  // Send new password callback
  const updatePassword = (newPassword) => {
    setLoading(true);
    setError(null);

    // Ask Firebase to send an email to reset password
    return firebase
      .doPasswordUpdate(newPassword)
      .catch(error => {
        const message = t(Firebase.getErrorTranslation(t, error.code)) + " (code: " + error.code + ")";
        setError(message);
        return Promise.reject(message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const {t, loading: tLoading} = useTranslationAuthenticationNoUi();
  const firebase = useFirebase();
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);

  return ({
    updatePassword,
    loading: loading || tLoading,
    error}
  );
}
